import lang from '../data/translations.json';

export const LANGUAGE_CODES = ['es', 'de', 'tr', 'pt'] as const;

export type LanguageCode = 'en' | (typeof LANGUAGE_CODES)[number];

export const LOCALIZED_PAGES = ['privacy', 'contact', 'about', 'terms', 'faq', 'how-it-works'] as const;

export function localizedPageFromPath(pathname = ''): (typeof LOCALIZED_PAGES)[number] | null {
  const segments = pathname.split('/').filter(Boolean);
  const page = LANGUAGE_CODES.includes(segments[0] as (typeof LANGUAGE_CODES)[number])
    ? segments[1]
    : segments[0];
  return LOCALIZED_PAGES.includes(page as (typeof LOCALIZED_PAGES)[number])
    ? (page as (typeof LOCALIZED_PAGES)[number])
    : null;
}

export function getLanguageFromPath(pathname = ''): LanguageCode {
  const firstSegment = pathname.split('/').filter(Boolean)[0];
  return LANGUAGE_CODES.includes(firstSegment as (typeof LANGUAGE_CODES)[number])
    ? (firstSegment as (typeof LANGUAGE_CODES)[number])
    : 'en';
}

export function isHomePath(pathname = ''): boolean {
  return pathname === '/' || /^\/(es|de|tr|pt)\/?$/.test(pathname);
}

export function getTranslations(pathname = '') {
  const languageCode = getLanguageFromPath(pathname);
  return lang[languageCode] || lang.en;
}

export function localeHomePath(pathname = ''): string {
  const languageCode = getLanguageFromPath(pathname);
  return languageCode === 'en' ? '/' : `/${languageCode}/`;
}

export function localePath(pathname = '', page: string): string {
  const home = localeHomePath(pathname);
  return home === '/' ? `/${page}/` : `${home}${page}/`;
}
